import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useGenders } from "../../hooks";
import { Tag } from "antd";
const Gender = (props) => {
  const { text } = props;
  const intl = useIntl();
  const [gender, setGender] = useState(null);

  const genders = useGenders();
  useEffect(() => {
    const selected = genders
      ? genders.filter((item) => item.id === text)[0]
      : null;
    if (selected) {
      setGender(selected["name"]);
    }
  }, [genders, text]);

  return gender ? (
    <Tag>
      {intl.formatMessage({
        id: `app.dataSelect.gender_id.${gender}`,
      })}
    </Tag>
  ) : null;
};

export default Gender;
